import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, SimpleChanges} from '@angular/core';
import {TFormState} from '../../../../models/forms.model';
import {ContractFinanceService} from '../../services/contract-finance.service';
import {IContractDataModel, IWalletFullData} from '../../models/contract-internal-models';
import {FinanceService} from '../../../../services/api/finance.service';
import {MatDialog} from '@angular/material/dialog';
import {PaymentModalComponent} from '../../../../components/payments/payment-modal/payment-modal.component'
import {FinanceWalletModel} from '../../../../models/finance.model';
import {AppContractBlockFinanceWalletSelectComponent} from '../contract-block-finance-wallet-select/contract-block-finance-wallet-select.component';
import {catchError, EMPTY, Subscription} from 'rxjs';
import {AlertService} from '../../../../services/notify/alert.service';
import {MemberModel} from '../../../../models/user.model';
import {ContractFormService} from '../../services/contract-form.service';

@Component({
    selector: 'app-contract-block-finance',
    templateUrl: './contract-block-finance.component.html',
    styleUrl: './contract-block-finance.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush
})
export class AppContractFinanceBlockComponent {
	@Input({required:true}) currentMember!:MemberModel
	@Input({required:true}) contractData!:IContractDataModel
	@Input() isFinanceBlockAvailable:boolean = false
    private subs: Subscription = new Subscription()
    public financeData: IWalletFullData | null = null;
	public hideFinanceBlock:boolean = false
	public formState:TFormState = 'Default'
	public wallet:FinanceWalletModel|null = null
	constructor (
		private contractFinanceService:ContractFinanceService,
		private contractFormService:ContractFormService,
		private financeService:FinanceService,
		private alertService:AlertService,
		private dialog: MatDialog,
        private cds:ChangeDetectorRef
	) {}

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges): void {
        changes?.isFinanceBlockAvailable?.currentValue ? this.getFinanceData() : null;
        this.cds.detectChanges();
    }

    getFinanceData() {
        this.subs.add(
            this.contractFinanceService.getCurrentWalletAndForecasts(
                this.contractData.contract!,
                this.currentMember!,
                this.contractData.currentProjectGuid)
                .pipe(catchError(()=>{
                    this.formState = 'Default'
                    this.isFinanceBlockAvailable = false
                    this.cds.detectChanges()
                    return EMPTY
                }))
                .subscribe(data => {
                    this.financeData = data
                    this.cds.detectChanges()
                })
        );
    }

    showTransactions(data: IWalletFullData) {
        this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(() => {
            this.formState = 'Submitting'
            this.financeService.getPaymentsHistory(data.wallet.wallet.guid)
                .pipe(
                    catchError(e => {
                        this.formState = 'Default'
                        this.cds.detectChanges()
                        this.alertService.setAlert(e.message, 'blue')
                        return EMPTY
                    }))
                .subscribe(ps => {
                    this.formState = 'Default'
                    this.cds.detectChanges()
                    let dialogRef = this.dialog.open(PaymentModalComponent, {
                        maxHeight: '95%',
                        width: '80%',
                        maxWidth: '95vw'
                    });
                    dialogRef.componentInstance.payments = ps.payments!.data;
                    dialogRef.componentInstance.detail = false;
                    dialogRef.componentInstance.walletProjectGuid = this.wallet?.project_guid || '';
                });
        });
    }

    changeAccount(data: IWalletFullData) {
        this.contractFormService.checkInterDomainRedirect(this.contractData?.contract?.contract).subscribe(() => {
            let dialogRef = this.dialog.open(AppContractBlockFinanceWalletSelectComponent, {
                maxHeight: '95%',
                width: '50%',
                maxWidth: '95vw',
                panelClass: 'project-select-padding-modalbox'
            })
            dialogRef.componentInstance.contractData = this.contractData
            dialogRef.componentInstance.availableWallets = data.forecast.forecast.forecast_wallets.map(el => {
                return {
                    guid: el.wallet?.guid || '',
                    title: el.wallet?.title || ''
                }
            })
            dialogRef.afterClosed().subscribe((res: any) => res ? this.getFinanceData() : null)
        })
    }
}